import React from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

// Updated CardIconAndTitle component to handle dual values
export default function CardIconAndTitle({
  icon,
  title,
  score,
  error,
  dualValues,
  onClick,
  subtitle,
}) {
  return (
    <Card
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "2 2 1 2",
        borderLeft: "8px solid #091f33",
        boxShadow: "1px 4px 10px rgba(0, 0, 0, 0.24)",
        borderRadius: "16px",
        width: "100%",
        minHeight: 100,
        cursor: onClick ? "pointer" : "default",
        transition: onClick ? "all 0.3s ease" : "none",
        "&:hover": onClick
          ? {
              boxShadow: "1px 6px 15px rgba(0, 0, 0, 0.3)",
              transform: "translateY(-2px)",
            }
          : {},
      }}
    >
      {/* Icon Box */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 2,
          height: "100%",
        }}
      >
        {icon}
      </Box>

      {/* Text Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          height: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          color="text.secondary"
          sx={{ fontWeight: 600, lineHeight: 1.2 }}
        >
          {title}
        </Typography>

        {/* Handle dual values display */}
        {dualValues ? (
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 2, mt: "4px" }}
          >
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "success.main" }}
              >
                {dualValues.value1}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {dualValues.label1}
              </Typography>
            </Box>
            <Typography variant="h6" color="text.secondary">
              /
            </Typography>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "warning.main" }}
              >
                {dualValues.value2}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {dualValues.label2}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography variant="h5" sx={{ fontWeight: 700, mt: "4px" }}>
            {score}
          </Typography>
        )}

        {subtitle && (
          <Typography
            variant="caption"
            color="primary"
            sx={{
              fontWeight: 500,
              marginTop: 0.5,
            }}
          >
            {subtitle}
          </Typography>
        )}

        {error && (
          <Typography
            variant="body2"
            sx={{
              color: "error.main",
              fontWeight: 600,
              marginTop: 0.5,
            }}
          >
            {error}
          </Typography>
        )}
      </Box>
    </Card>
  );
}
